export default __webpack_public_path__ + "static/niche@992_2x-356e89c84148b942f3e57fd045c59fa5.webp";